<script setup lang="ts">
import { computed } from 'vue'
import Modal from '@/components/modals/Modal.vue'
import usePremiumMembershipModal from '@/composables/usePremiumMembershipModal'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { premiumMembershipModal, hidePremiumMembershipModal } = usePremiumMembershipModal()
const MEMBERSHIP_PRICING_URL = window.ENV.MEMBERSHIP_PRICING_URL
const premiumFeatures = computed(() => [
  t('Unlock all Processors'),
  t('Integrate your SAP System'),
  t('Premium Support'),
  t('Advanced AI Models'),
])
</script>

<template>
  <Modal
    id="premium-membership-modal"
    ref="premiumMembershipModal"
    size="xl"
    body-classes="m-0 p-0"
    :enable-close="false"
    border-classes="border border-transparent rounded-2"
    backdrop-blur
  >
    <div class="top-right-controls top-0 end-0 pe-3 pt-3">
      <button class="btn btn-white bg-transparent rounded-circle d-flex p-2" @click="hidePremiumMembershipModal">
        <i-icon-park-outline-close class="text-dark"></i-icon-park-outline-close>
      </button>
    </div>

    <div class="row g-0">
      <div class="col-12 col-lg-7">
        <div class="premium-intro bg-white h-100 d-flex flex-column p-5 pe-xl-6">
          <h1 class="fw-normal mb-2">
            {{ t('Unlock the') }}
            <span class="text-success">{{ t('full power') }}</span>
            {{ t('of Microbrains') }}
          </h1>
          <p class="mb-4 text-primary-800">
            {{ t('Talk to us and unlock all premium features for advanced AI process automation with Microbrains.') }}
          </p>

          <img src="/img/premiumMembership.svg" class="premium-image" alt="" />
        </div>
      </div>

      <div class="col-12 col-lg-5 bg-primary bg-opacity-10">
        <div class="premium-benefits h-100 d-flex flex-column p-4 p-lg-5 mx-3">
          <small class="text-muted text-uppercase mb-4">{{ t('Premium features') }}</small>

          <ul class="list-unstyled my-4">
            <li v-for="feature in premiumFeatures" :key="feature" class="d-flex align-items-start mb-3">
              <div class="bg-success bg-opacity-15 d-flex align-items-center justify-content-center rounded-circle">
                <i-bi-check class="text-success fs-5 flex-shrink-0" />
              </div>
              <h5 class="fw-light mb-0 ms-3">{{ t(feature) }}</h5>
            </li>
          </ul>

          <div class="d-grid gap-2 mt-auto">
            <a
              v-if="MEMBERSHIP_PRICING_URL"
              :href="MEMBERSHIP_PRICING_URL"
              target="_blank"
              class="btn btn-primary bg-gradient-dark-green py-3 border border-transparent fw-semibold"
            >
              {{ t('Contact Us') }}
            </a>
            <!-- <button class="btn btn-outline-dark-green py-3" @click="hidePremiumMembershipModal">
              {{ t('See Pricing') }}
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
@import '@/assets/scss/themes/microbrains';
@import '@/assets/scss/util';

.top-right-controls {
  position: absolute;
  z-index: 100;
}

.premium-intro {
  border-top-left-radius: var(--bs-border-radius);
  border-top-right-radius: var(--bs-border-radius);
}

.premium-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

@include media-breakpoint-up(lg) {
  .premium-intro {
    border-radius: var(--bs-border-radius) 0 0 var(--bs-border-radius);
  }
}
</style>
